<template>
    <div class="authorization-content_bg"></div>
    <main class="authorization-content">
      <div class="autorization">
        <div class="autorization__body popup box bg-white">
          <form id="registration-form" name="registration-form" @submit.prevent="submitForm" method="post">
            <div class="popup__header">
              <div class="popup__title section__title section__title_style3">{{ $t("registrationInCabinet") }}</div>
              <div class="form-alt-ofd">
                <img src="/images/svg/error_circle.svg">
                <span>
                  {{ $t("informationForOFD")}} 
                  <a href="https://ofd.ttc.kz/">https://ofd.ttc.kz/</a>
                </span>
              </div>
              <div class="popup__logo svg-icon" aria-hidden="true">
                <svg role="img" width="63" height="24" aria-hidden="true">
                  <use xlink:href="#svg-logo-mobile"></use>
                </svg>
              </div>
            </div>
            <div class="popup__body">
              <div class="form-group">
                <label class="form-label form-label_hidden" for="last_name">{{ $t("surname", { sym: '*' }) }}</label>
                <input class="form-control" title="Обязательное поле" type="text" :class="{is_invalid: v$.userData.last_name.$error}" v-model.trim="userData.last_name" name="last_name" id="last_name" :placeholder='$t("surname", { sym: "*" })'>
                <div class="form-validator" :class="{is_invalid: v$.userData.last_name.$error}">{{ $t("requiredInput") }}</div>
              </div>
              <div class="form-group">
                <label class="form-label form-label_hidden" for="first_name">{{ $t("name", { sym: "*" }) }}</label>
                <input class="form-control" title="Обязательное поле" type="text" :class="{is_invalid: v$.userData.first_name.$error}" v-model.trim="userData.first_name" name="first_name" id="first_name" :placeholder='$t("name", { sym: "*" })'>
                <div class="form-validator" :class="{is_invalid: v$.userData.first_name.$error}">{{ $t("requiredInput") }}</div>
              </div>
              <div class="form-group">
                <label class="form-label form-label_hidden" for="patronymic">{{ $t("patronymic") }}</label>
                <input class="form-control" type="text" v-model.trim="userData.patronymic" name="patronymic" id="patronymic" :placeholder='$t("patronymic")'>
                <!-- <div class="form-validator" :class="{is_invalid: v$.userData.patronymic.$error}">{{ $t("requiredInput") }}</div> -->
              </div>
              <div class="form-group">
                <label class="form-label form-label_hidden" for="user-email-registration">{{ $t("eMail", { sym: "*" }) }}</label>
                <input class="form-control" title="Обязательное поле" type="email" :class="{is_invalid: v$.userData.email.$error}" v-model.trim="userData.email" name="user-email-registration" id="user-email-registration" :placeholder='$t("eMail", { sym: "*" })'>
                <div class="form-alt">{{ $t("altForReg") }}</div>
                <div class="form-validator" :class="{is_invalid: v$.userData.email.$error}">{{ $t("incorrectEmail") }}</div>
                <div class="form-validator" ref="email_error">{{ $t("existsData")}}</div>
                <div class="form-validator" ref="email2_error">{{ $t("incorrectValue")}}</div>
              </div>
              <div class="form-group">
                <label class="form-label form-label_hidden" for="user-tel-registration">{{ $t("phoneNumber", { sym: "*" }) }}</label>
                <input class="form-control" title="Обязательное поле" v-mask="'+7 (###) ### ## ##'" type="tel" :class="{is_invalid: v$.userData.phone.$error}" v-model.trim="userData.phone" name="user-tel-registration" id="user-tel-registration" placeholder="+7 - - - - - - - - - - *">
                <div class="form-alt">{{ $t("altForReg") }}</div>
                <div class="form-validator" :class="{is_invalid: v$.userData.phone.$error}">{{ $t("incorrectPhoneNumber") }}</div>
                <div class="form-validator" ref="phone_error">{{ $t("existsData")}}</div>
                <div class="form-validator" ref="phone2_error">{{ $t("incorrectValue")}}</div>
              </div>
              <div class="form-group">
                <label class="form-label form-label_hidden" for="password">{{ $t("reqPassword", { sym: "*" }) }}</label>
                <input class="form-control" title="Обязательное поле" @blur="this.v$.userData.password.$touch()" type="password" :class="{is_invalid: v$.userData.password.$error}" v-model.trim="userData.password" name="password" id="password" :placeholder='$t("reqPassword", { sym: "*" })'>
                <div class="form-validator" :class="{is_invalid: v$.userData.password.$error}">{{ $t("incorrectPassword") }}</div>
                <div class="form-validator" ref="password_error">{{ $t("incorrectPassword") }}</div>
                <div class="form-validator" ref="password2_error">{{ $t("commonPassword")}}</div>
              </div>
              <div class="form-group">
                <label class="form-label form-label_hidden" for="password_confirm">{{ $t("repeatPassword", { sym: "*" }) }}</label>
                <input class="form-control" title="Обязательное поле" @blur="this.v$.userData.password_confirm.$touch()" type="password" :class="{is_invalid: v$.userData.password_confirm.$error}" v-model.trim="userData.password_confirm" name="password_confirm" id="password_confirm" :placeholder='$t("repeatPassword", { sym: "*" })'>
                <div class="form-validator" :class="{is_invalid: v$.userData.password_confirm.$error}">{{ $t("incorrectRepeatPass") }}</div>
              </div>

              <div class="form-group">
                <label class="form-label form-label_hidden" for="iin">{{ $t("iin", { sym: "*" }) }}</label>
                <input class="form-control" title="Обязательное поле" type="text" :class="{is_invalid: v$.userData.profile.iin.$error}" v-model.trim="userData.profile.iin" name="iin" id="iin" :placeholder='$t("iin", { sym: "*" })'>
                <div class="form-validator" :class="{is_invalid: v$.userData.profile.iin.$error}">{{ $t("incorrectIIN") }}</div>
                <div class="form-validator" ref="iin_error">{{ $t("existsData")}}</div>
                <div class="form-validator" ref="iin2_error">{{ $t("incorrectValue")}}</div>
                <div class="form-validator" ref="iin3_error">{{ $t("ageError")}}</div>
              </div>
              <div class="form-group">
                <label class="form-label form-label_hidden" for="city">{{ $t("cityforreg", { sym: "*" }) }}</label>
                <input class="form-control" title="Обязательное поле" type="text" :class="{is_invalid: v$.userData.profile.city.$error}" v-model.trim="userData.profile.city" name="city" id="city" :placeholder='$t("cityforreg", { sym: "*" })'>
                <div class="form-validator" :class="{is_invalid: v$.userData.profile.city.$error}">{{ $t("requiredInput") }}</div>
              </div>
              <div class="form-group">
                <label class="form-label form-label_hidden" for="branch">{{ $t("region", { sym: "*" }) }}</label>
                <select v-model.trim="userData.id_department" class="form-control" required name="branch" id="branch">
                  <option value="" selected disabled>{{ $t("region", { sym: '*' }) }}</option>
                  <option value="1">Алматы</option>
                  <option value="2">Астана</option>
                  <option value="3">Актобе</option>
                  <option value="4">Атырау</option>
                  <option value="5">Жамбыл</option>
                  <option value="6">Кокшетау</option>
                  <option value="7">Караганда</option>
                  <option value="8">Костанай</option>
                  <option value="9">Кызылорда</option>
                  <option value="10">Оскемен</option>
                  <option value="11">Павлодар</option>
                  <option value="12">Семей</option>
                  <option value="14">Шымкент</option>
                  <option value="17">Актау</option>
                </select>
                <div class="form-validator" :class="{is_invalid: v$.userData.id_department.$error}">{{ $t("requiredInput") }}</div>
              </div>
              <div class="form-group">
                <label class="form-label form-label_hidden" for="address">{{ $t("address", { sym: "*" }) }}</label>
                <input class="form-control" title="Обязательное поле" type="text" :class="{is_invalid: v$.userData.profile.address.$error}" v-model.trim="userData.profile.address" name="address" id="address" :placeholder='$t("address", { sym: "*" })'>
                <div class="form-validator" :class="{is_invalid: v$.userData.profile.address.$error}">{{ $t("requiredInput") }}</div>
              </div>
              <!-- <div class="form-group">
                <label class="form-label form-label_hidden" for="document_series">Серия документа</label>
                <input class="form-control" type="text" :class="{is_invalid: v$.userData.profile.document_series.$error}" v-model.trim="userData.profile.document_series" name="document_series" id="document_series" :placeholder="Серия документа">
                <div class="form-validator" :class="{is_invalid: v$.userData.profile.document_series.$error}">{{ $t("requiredInput") }}</div>
              </div> -->
              <div class="form-group">
                <label class="form-label form-label_hidden" for="document_number">{{ $t("docNumber", { sym: "*" }) }}</label>
                <input class="form-control" title="Обязательное поле" min="0" type="number" :class="{is_invalid: v$.userData.profile.document_number.$error}" v-model.trim="userData.profile.document_number" name="document_number" id="document_number" :placeholder='$t("docNumber", { sym: "*" })'>
                <div class="form-validator" :class="{is_invalid: v$.userData.profile.document_number.$error}">{{ $t("requiredInput") }}</div>
              </div>
              <div class="form-group">
                <label class="form-label form-label_hidden" for="document_issue_date">{{ $t("issueDate", { sym: "*" }) }}</label>
                <input class="form-control" title="Обязательное поле" :type="inputType" @focus="this.inputType='date'" :class="{is_invalid: v$.userData.profile.document_issue_date.$error}" v-model.trim="userData.profile.document_issue_date" name="document_issue_date" id="document_issue_date" :placeholder='$t("issueDate", { sym: "*" })'>
                <div class="form-validator" :class="{is_invalid: v$.userData.profile.document_issue_date.$error}">{{ $t("requiredInput") }}</div>
              </div>
              <div class="form-group">
                <label class="form-label form-label_hidden" for="document_issuer">{{ $t("issuePlace", { sym: "*" }) }}</label>
                <input class="form-control" title="Обязательное поле" type="text" :class="{is_invalid: v$.userData.profile.document_issuer.$error}" v-model.trim="userData.profile.document_issuer" name="document_issuer" id="document_issuer" :placeholder='$t("issuePlace", { sym: "*" })'>
                <div class="form-validator" :class="{is_invalid: v$.userData.profile.document_issuer.$error}">{{ $t("requiredInput") }}</div>
              </div>
              <div class="form-group">
                <label class="form-label form-label_hidden" for="phonePHN">{{ $t("homePhoneNumber") }}</label>
                <input class="form-control" type="text" v-model.trim="userData.profile.phonePHN" name="phonePHN" id="phonePHN" :placeholder='$t("homePhoneNumber")'> 
                <!-- <div class="form-validator" :class="{is_invalid: v$.userData.profile.phonePHN.$error}">{{ $t("requiredInput") }}</div> -->
                <!-- <div class="form-validator" ref="phonePHN_error"></div> -->
              </div>
              <!-- <div class="form-group">
                <label class="form-label form-label_hidden" for="description">Описание</label>
                <input class="form-control" type="text" :class="{is_invalid: v$.userData.profile.description.$error}" v-model.trim="userData.profile.description" name="description" id="description" placeholder="Описание">
                <div class="form-validator" :class="{is_invalid: v$.userData.profile.description.$error}">{{ $t("requiredInput") }}</div>
              </div> -->
              <div class="agree__block"><input :class="{is_invalid: v$.isAgree.$error}" type="checkbox" v-model="isAgree" ><a target="_blank" :href='$t("agreedoc")'> {{ $t("agreeReg") }}</a></div>
            </div>
            <div class="popup__footer">
              <div class="row align-items-center justify-content-between">
                <div class="col-12 col-sm-auto order-sm-last">
                  <button :disabled="!isAgree" :class="{is_disabled: !isAgree}" class="btn btn_default btn_white" type="submit">{{ $t("register") }}</button>
                </div>
                <div class="col-12 col-sm-auto"><router-link class="link link_gray" to="/login">{{ $t("cancel") }}</router-link></div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </main>

    <div class="modal fade modal_message" ref="modalSuccess" aria-label="Операция прошла успешно" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div class="modal-title section__title section__title_style3">
                {{$t("regSuccessTitle")}}
            </div>
            <button class="btn svg-icon modal-close" type="button" data-dismiss="modal" @click="closeModal" :aria-label='$t("close")'>
              <svg role="img" width="14" height="14" aria-hidden="true">
                <use xlink:href="#svg-icon-close"></use>
              </svg>
            </button>
          </div>
          <div class="modal-body">
            <div class="section__description color-green">
              <p>{{$t("regSuccessText")}}</p>
            </div>
            <!-- <router-link to="/login" class="btn btn_default btn_white btn_message" tupe="button" data-dismiss="modal">{{ $t("go") }}</router-link> -->
          </div>
        </div>
      </div>
    </div>  
</template>
<script>
import useValidate from "@vuelidate/core";
import { required, email, sameAs, minLength } from "@vuelidate/validators";
import ModalWindow from "@/components/UI/ModalWindow";
import {mapActions} from 'vuex'
export default {
  components: {
    ModalWindow
  },
  data(){
    return {
      v$: useValidate(),
      userData: {
        last_name: '',
        first_name: '',
        patronymic: '',
        phone: '',
        email: '',
        password: '',
        password_confirm: '',
        id_department: '',
        profile: {
          iin: '',
          city: '',
          address: '',
          // document_series: '',
          document_number: '',
          document_issue_date: '',
          document_issuer: '',
          phonePHN: '',
          // description: ''
        }
      },
      isAgree: false,
      inputType: 'text'
    }
  },
  validations() {
  	return {
      userData: {
        last_name: { required },
        first_name: { required },
        // patronymic: { required },
        phone: { required },
        email: { required, email },
        password: { 
          required,
          minLength: minLength(8),
          containsUppercase: function(value) {
            return /[A-Z]/.test(value)
          },
          containsLowercase: function(value) {
            return /[a-z]/.test(value)
          },
          containsNumber: function(value) {
            return /[0-9]/.test(value)
          },
          // containsSpecial: function(value) {
          //   return /[#?!@$%^&*-]/.test(value)
          // }
        },
        password_confirm: { 
          required, 
          sameAsPassword: sameAs(this.userData.password),
        },
        id_department: { required },
        profile: {
          iin: { 
            required, 
          },
          city: { required },
          address: { required },
          // document_series: { required },
          document_number: { required },
          document_issue_date: { required },
          document_issuer: { required },
          // phonePHN: { required },
          // description: { required },
        },
      },
      isAgree: { required }
  	}
  },
  methods: {
    ...mapActions({
      reg: 'authorization/registration',
    }),
    submitForm() {    
      this.resetStyles()
      this.v$.$validate() 
  		if (!this.v$.$error) { 
        const userData = this.userData
        
        const {phone} = userData
        if (phone.startsWith("+7") && phone.includes("(")){
          userData.phone = phone.replace(/\s+/g, '').replace('(', '').replace(')', '').slice(2);
        }

        const {email} = userData
        userData.email = email.toLowerCase()

  			this.reg(userData).then((res) => {
          if(res === 200 || res === 201){
            this.$refs.modalSuccess.classList.add('show-modal')
          }else if(res.status === 400){
            let resData = res.data
            for (let key in resData) {
              if (key === 'profile'){
                let profError = resData[key]
                for (let key2 in profError) {
                  if (profError[key2][0].includes("уникальны")){
                    let refName = key2+"_error"
                    this.$refs[refName].classList.add('is_invalid')
                  }else if(profError[key2][0].includes("18")){
                    let refName = key2+"3_error"
                    this.$refs[refName].classList.add('is_invalid')
                  }else{
                    let refName = key2+"2_error"
                    this.$refs[refName].classList.add('is_invalid')
                  }
                }
                continue;
              }
              if (resData[key][0].includes("уникальны")){
                let refName = key+"_error"
                this.$refs[refName].classList.add('is_invalid')
              }else{
                let refName = key+"2_error"
                this.$refs[refName].classList.add('is_invalid')
              }
            }
            window.scrollTo(0,0);
          }
        })
  		}
      window.scrollTo(0,0);
    },
    resetStyles(){
      for (var key in this.$refs) {
        if(key.endsWith('_error')){
          this.$refs[key].classList.remove('is_invalid');
        }
      }
      // document.querySelectorAll('[class$="_error"]').classList.remove('is_invalid');
    },
    closeModal(){
      // console.log(this.$refs.modalSuccess)
      this.$refs.modalSuccess.classList.remove('show-modal')
    }
  },
  watch: {
    userData: {
      handler(data) {
        console.log(data)
      },
      deep: true
    },
  }
}
</script>
<style scoped>
  .is_invalid{
    border: 1px solid #dd2727;
    opacity: 1;
    visibility: inherit;
  }
  .authorization-content_bg{
    position: fixed;
    width: 100%;
    height: 100vh;
    top: 0;
    left: 0;
    background-position: top right;
    background-repeat: no-repeat;
    background-size: auto 100%;
    background-attachment: fixed;
  }
  .authorization-content{
    height: 100%;
  }
  .autorization{
    height: auto;
  }
  .autorization__body{
    z-index: 6;
  }
  .agree__block{
    color: #636363;
    font-size: .9em;
  }
  .error__block{
    color: #dd2727;
    margin-top: 10px;
  }
  .is_disabled{
    background-color: #ddd;
    color: #a7a7a7;
    border-color: #ddd;
  }
  .modal_message{
    -webkit-box-shadow: 0px 3px 20px 23px rgba(34, 60, 80, 0.2);
    -moz-box-shadow: 0px 3px 20px 23px rgba(34, 60, 80, 0.2);
    box-shadow: 0px 3px 20px 23px rgba(34, 60, 80, 0.2);
  }
  .modal-body{
    text-align: center !important;
  }
  .show-modal{
    display: block !important;
    opacity: 1 !important;
    background: rgba(255,255,255,.5);
  }
  .footer{
    position: relative;
  }
  .form-alt{
    font-size: 0.7em;
    color: #979797;
    padding-top: 3px;
  }
  .form-alt-ofd{
    font-size: 0.8em;
    color: #979797;
    padding-top: 10px;
    display: flex;
    column-gap: 7px;
    align-items: flex-start;
  }
  .form-alt-ofd img{
    width: 15px;
  }
  .form-validator{
    font-size: .8em;
  }
</style>